import React from 'react'
import { Container, Row, Col, Button, Nav, NavItem, NavLink } from 'reactstrap';
import { browserHistory, Link } from 'react-router';

import Loader from '../../core/components/Loader'
import FormStepNew from '../containers/FormStepNewContainer'
import FormStepOne from '../containers/FormStepOneContainer'
import FormStepTwo from '../containers/FormStepTwoContainer'
import FormStepThree from '../containers/FormStepThreeContainer'
import FormStepFour from '../containers/FormStepFourContainer'

import Back from 'react-icons/lib/md/keyboard-arrow-left'

import '../styles/style.css';

class Provider extends React.Component {

	constructor(props) { 
        super(props);

        this.nextPage = this.nextPage.bind(this)
        this.previousPage = this.previousPage.bind(this)
        this.closePage = this.closePage.bind(this)
        this.state = {
          page: 1,
          responsive:false,
          create: this.props.create ? this.props.create : false
        }
    }

    nextPage() {
        this.setState({ page: this.state.page + 1 })
    }

    previousPage() {
        this.setState({ page: this.state.page - 1 })
    }

    componentDidMount() {
        if( window.innerWidth < 520)
            this.setState({responsive:true})

        if(this.props.provider_id)
            this.props.retrieveProvider(this.props.provider_id)
    }

    changePage(page){

        if(!this.state.create)
            this.setState({ page })
    }

    closePage(){
        if(this.props.user.role === "provider")
            browserHistory.push('/prestataire/fiche');
        else
            browserHistory.push('/manager/prestataire/'+this.props.provider.provider.id)
    }

    render() {
    	const { provider, user } = this.props

    	
    	return (
            <div className="provider-bloc">
                <Row>
                    {this.state.responsive &&
                      <Col>
                        <div className="provider-bloc-resp-back" onClick={() => this.closePage()}>
                           <Back />
                        </div>

                        <div className="provider-bloc-resp-select" >
                           <select onChange={(event) => this.changePage(parseInt(event.target.value))}>
                              <option value={1} selected={this.state.page === 1 ? true : false}>Coordonnées</option>
                              <option value={2} selected={this.state.page === 2 ? true : false}>Informations administatives</option>
                              <option value={3} selected={this.state.page === 3 ? true : false}>Informations opérationnelles</option>
                              <option value={4} selected={this.state.page === 4 ? true : false}>Documents</option>
                           </select>
                        </div>

                      </Col>
                    }

                    {!this.state.responsive &&
                    <Col>
                        {user.role === "provider" && !this.props.lead &&
                            <Link to="/prestataire/fiche"><Button className="btn-transparent"> Voir ma fiche </Button></Link>
                         }

                         {user.role === "manager" && !this.props.lead &&
                            <Link to={"/manager/prestataire/"+this.props.provider_id}><Button className="btn-transparent"> Voir la fiche </Button></Link>
                         }


                         {this.props.lead && !provider.provider && 
                            <Link to={"/manager/leads/"}><Button className="btn-transparent"> Retour </Button></Link>
                         }

                         {this.props.lead && provider.provider && 
                            <Link to={"/manager/prestataire/"+provider.provider.id}><Button className="btn-transparent"> Voir la fiche </Button></Link>
                         }
                        
                    
                        <Nav className="provider-navbar">
                          <NavItem className={this.state.page === 1 ? 'active' : '' }>
                            <div onClick={() => this.changePage(1)} className="provider-navbar-item">Coordonnées</div>
                          </NavItem>
                          <NavItem className={this.state.page === 2 ? 'active' : '' }>
                            <div onClick={() => this.changePage(2)} className="provider-navbar-item">Informations administatives</div>
                          </NavItem>
                          <NavItem className={this.state.page === 3 ? 'active' : '' }>
                            <div  onClick={() => this.changePage(3)}className="provider-navbar-item">Informations opérationnelles</div>
                          </NavItem>
                          <NavItem className={this.state.page === 4 ? 'active' : '' }>
                            <div onClick={() => this.changePage(4)} className="provider-navbar-item">Documents</div>
                          </NavItem>
                        </Nav>
                    </Col>
                    }
                </Row>

                {provider.pending && !provider.provider && !this.props.lead &&
                    <Loader />
                }

                {provider.provider &&
                    <div>
                        {this.state.page === 1 && !this.props.lead && <FormStepOne closePage={this.closePage} nextPage={this.nextPage} previousPage={this.previousPage} create={this.state.create} />}
                        {this.state.page === 2 && <FormStepTwo closePage={this.closePage} nextPage={this.nextPage} previousPage={this.previousPage} create={this.state.create} />}
                        {this.state.page === 3 && <FormStepThree closePage={this.closePage} nextPage={this.nextPage} previousPage={this.previousPage} create={this.state.create} />}
                        {this.state.page === 4 && <FormStepFour closePage={this.closePage} nextPage={this.nextPage} previousPage={this.previousPage} create={this.state.create} newLead={this.props.lead} />}
                    </div>
                }

                {this.props.lead && 
                    <div>
                        {this.state.page === 1 && <FormStepNew newLead={true} closePage={this.closePage} nextPage={this.nextPage} previousPage={this.previousPage} create={this.state.create} />}
                    </div>
                }
                
            </div>
        )
    }
}


export default Provider



// WEBPACK FOOTER //
// ./src/provider/components/UpdateProvider.js